/* general : les composants partagés, la recherche ⌘K, les titres des pages,
 * le formulaire d'ajout de client, l'aide et « introuvable » (2026-09-30).
 * Même forme que `en/general.ts`. */
export default {
  ui: {
    breadcrumb: "Fil d'Ariane",
    back: 'Retour',
    updated: 'Mis à jour {when}',
    confirm: {
      title: 'Êtes-vous sûr ?',
      message: 'Cette action est irréversible.',
    },
    chips: {
      remove: 'Retirer « {label} »',
    },
    filters: {
      title: 'Filtres',
      close: 'Fermer les filtres',
    },
    bulk: {
      trademark: 'marque sélectionnée | marques sélectionnées',
      case: 'dossier sélectionné | dossiers sélectionnés',
      client: 'client sélectionné | clients sélectionnés',
      match: 'correspondance sélectionnée | correspondances sélectionnées',
      item: 'élément sélectionné | éléments sélectionnés',
      selected: 'sélectionné(s)',
      clear: 'Effacer la sélection',
    },
    pagination: {
      showing: 'Affichage de {range} sur {total} {unit}',
      items: 'éléments',
      prev: 'Page précédente',
      next: 'Page suivante',
    },
    toast: {
      region: "Messages d'état",
    },
    error: {
      offlineTitle: 'Vous semblez être hors ligne',
      offline: 'Vérifiez votre connexion et réessayez.',
      timeoutTitle: 'La requête a expiré',
      timeout: 'Le serveur a mis trop de temps à répondre. Réessayez dans un instant.',
      authTitle: 'Votre session a expiré',
      auth: 'Reconnectez-vous pour continuer ; vous reviendrez sur cette page.',
      rateTitle: 'Trop de requêtes',
      rate: 'Patientez quelques secondes et réessayez.',
      serverTitle: 'Le serveur rencontre des difficultés',
      generic: "Une erreur inattendue s'est produite. Réessayez dans un instant.",
      render: "Une erreur inattendue s'est produite lors de l'affichage de cette section.",
    },
    notFound: {
      title: {
        item: 'Introuvable',
        client: 'Client introuvable',
        trademark: 'Marque introuvable',
        report: 'Rapport introuvable',
        case: "Dossier d'opposition introuvable",
      },
      sub: "Il a peut-être été supprimé, le lien est peut-être obsolète, ou votre compte n'y a pas accès.",
    },
  },

  search: {
    label: 'Rechercher dans Lexentiqa',
    placeholder: 'Rechercher des marques, clients et dossiers…',
    hint: "Saisissez au moins deux lettres pour rechercher des marques, des clients et des dossiers d'opposition.",
    searching: 'Recherche…',
    noResults:
      'Aucun résultat pour « {q} ». Essayez un nom de marque, un client ou un numéro de dossier.',
    failed: "La recherche n'est pas disponible pour le moment. Réessayez dans un instant.",
    navigate: 'naviguer',
    open: 'ouvrir',
    close: 'fermer',
    anywhere: 'partout',
  },

  route: {
    dashboard: 'Tableau de bord',
    monitoring: 'Surveillance des marques',
    matchDetail: 'Examen de la correspondance',
    trademarks: 'Mes marques',
    trademarkNew: 'Ajouter une marque',
    trademarkDetail: 'Fiche de la marque',
    oppositions: "Dossiers d'opposition",
    oppositionNew: "Nouveau dossier d'opposition",
    oppositionDetail: "Dossier d'opposition",
    reports: 'Rapports',
    reportDetail: "Rapport d'analyse",
    clients: 'Clients',
    clientNew: 'Ajouter un client',
    clientDetail: 'Fiche client',
    people: 'Personnes',
    personNew: 'Nouvelle personne',
    person: 'Fiche personne',
    clientEdit: 'Modifier le client',
    notifications: 'Notifications',
    help: "Centre d'aide",
    howItWorks: 'Comment fonctionne la surveillance',
    roadmap: 'Ce que nous construisons',
    account: 'Compte',
    settings: 'Paramètres',
    styleguide: 'Guide de style',
    signIn: 'Connexion',
    forgotPassword: 'Réinitialiser votre mot de passe',
    setPassword: 'Définir votre mot de passe',
    notFound: 'Introuvable',
  },

  addClient: {
    subtitle:
      "Ajoutez un nouveau titulaire de marques à l'espace de travail. La surveillance se règle marque par marque, une fois ses marques ajoutées.",
    create: 'Créer le client',
    creating: 'Création…',
    workspace: "Ajout d'un client",
    required: 'Obligatoire',
    company: {
      title: 'Informations sur la société',
      sub: "L'entité juridique titulaire des marques.",
      name: 'Dénomination sociale',
      namePlaceholder: 'ex. Exemple SARL',
      nameHint: 'La dénomination complète, telle qu’inscrite au registre du commerce.',
      nameRequired: 'Saisissez la dénomination sociale du client.',
      nameShort: 'La dénomination doit comporter au moins {n} caractères.',
      tradingName: 'Nom commercial',
      tradingNamePlaceholder: 'S’il diffère de la dénomination sociale',
      legalForm: 'Forme juridique',
      legalFormPlaceholder: 'Choisissez la forme juridique…',
      registrationNumber: "Numéro d'immatriculation",
      registrationNumberPlaceholder: 'EIK / n° d’immatriculation',
      founded: 'Année de création',
      foundedPlaceholder: 'AAAA',
      industry: "Secteur d'activité",
      industryPlaceholder: 'Choisissez le secteur…',
      size: "Taille de l'entreprise",
      sizePlaceholder: 'Choisissez la taille…',
      website: 'Site web',
    },
    legalForm: {
      ood: 'OOD (SARL bulgare)',
      eood: 'EOOD (SARL unipersonnelle bulgare)',
      ad: 'AD (SA bulgare)',
      ead: 'EAD (SA unipersonnelle bulgare)',
      et: 'ET (entrepreneur individuel bulgare)',
      gmbh: 'GmbH (Allemagne, Autriche)',
      sa: 'SA / SARL (France et autres)',
      inc: 'Inc. / Corp. (États-Unis)',
      llc: 'LLC (États-Unis)',
      other: 'Autre',
    },
    industry: {
      software: 'Logiciels / SaaS',
      finance: 'Services financiers',
      manufacturing: 'Industrie manufacturière',
      cosmetics: 'Beauté / cosmétiques',
      pharma: 'Pharmacie / santé',
      biotech: 'Biotechnologies',
      beverages: 'Boissons',
      fashion: 'Mode / habillement',
      telecom: 'Télécommunications',
      other: 'Autre',
    },
    size: {
      s1: '1 à 10 salariés',
      s2: '11 à 50 salariés',
      s3: '51 à 200 salariés',
      s4: '201 à 500 salariés',
      s5: '501 à 1 000 salariés',
      s6: 'plus de 1 000 salariés',
    },
    hq: {
      title: 'Siège social',
      sub: 'Où la société elle-même est immatriculée. Les registres sur lesquels ses marques sont surveillées se choisissent marque par marque, pas ici.',
      country: 'Pays / région',
      countryPlaceholder: 'Choisissez le pays…',
    },
    contact: {
      title: 'Contact principal',
      sub: 'La personne à contacter chez le client. Enregistrée sur la fiche du client.',
      name: 'Nom du contact principal',
      namePlaceholder: 'Prénom et nom',
      nameRequired: 'Saisissez le nom du contact principal.',
      email: 'E-mail',
      emailRequired: "Saisissez l'adresse e-mail du contact.",
      emailInvalid: 'Saisissez une adresse e-mail valide.',
    },
    notes: {
      title: 'Notes internes',
      sub: 'Contexte pour votre équipe. Jamais montré au client.',
      label: 'Notes',
      placeholder:
        'Comment la relation a commencé, qui vous a présenté le client, tout ce que la prochaine personne qui reprendra le dossier doit savoir.',
    },
    rail: {
      label: "Aide à l'ajout",
      checklist: 'Étapes de l’ajout',
      step: 'Étape {n}.',
      step1: 'Renseignez les informations sur la société et le siège social.',
      step2: 'Indiquez la personne à contacter chez le client.',
      step3:
        'Une fois le client créé, ajoutez ses marques — chaque marque a son propre périmètre de surveillance.',
      done: 'Fait',
    },
    actions: 'Actions du formulaire',
    notSaved: "Rien n'est enregistré tant que vous n'avez pas créé le client.",
    incomplete: 'Complétez les champs obligatoires',
    created: 'Client créé',
    createdSub: '{name} a été ajouté à votre liste de clients.',
    failed: "Le client n'a pas été créé",
  },

  help: {
    title: "Centre d'aide",
    subtitle:
      'Comment fonctionne le produit, où trouver chaque chose, et des réponses courtes aux questions fréquentes.',
    topics: "Rubriques d'aide",
    topic: {
      howItWorks: 'Comment fonctionne la surveillance',
      howItWorksSub: 'Du bulletin du registre au conflit sur votre bureau, étape par étape',
      roadmap: 'Ce que nous construisons, et où nous en sommes',
      roadmapSub:
        'Le plan de développement complet en langage clair — terminé, en cours et à venir',
      trademarksSub:
        'Les marques de vos clients, les registres sur lesquels chacune est surveillée, et leurs documents',
      monitoringSub:
        'Ce que la surveillance a trouvé face aux marques de vos clients, et comment chaque paire a été tranchée',
    },
    faq: {
      title: 'Questions fréquentes',
      sub: 'Des réponses courtes sur le fonctionnement actuel du produit.',
      bulletins: {
        q: 'À quelle fréquence les nouveaux bulletins sont-ils collectés ?',
        a: "La plateforme vérifie toutes les trois heures si l'EUIPO et l'OMPI ont publié de nouveaux bulletins, et lit chacun une fois collecté. Les registres nationaux, y compris l'office bulgare, ne sont pas encore lus. La comparaison des nouveaux dépôts avec vos marques est une étape distincte, une analyse, lancée par l'opérateur de la plateforme ; chaque jour où une analyse a eu lieu a son propre rapport dans Rapports.",
      },
      sensitivity: {
        q: 'Pouvons-nous régler la sensibilité de la détection ?',
        a: "Pas cabinet par cabinet. La détection est réglée pour toute la plateforme par son opérateur, en fonction d'un objectif de rappel : la part des paires de marques ayant réellement fait l'objet d'une opposition devant l'EUIPO que le système doit soumettre à un juriste, mesurée sur les propres données d'opposition de l'EUIPO. Chaque correspondance indique comment elle a été tranchée — par une règle de correspondance, ou après lecture par le juge IA, avec ses motifs.",
      },
      clientAccess: {
        q: 'Un client peut-il avoir son propre accès en lecture seule ?',
        a: "Oui. Un compte client est en lecture seule. Il ne voit que les dossiers d'opposition ouverts sur ses propres marques et, dans ces dossiers, uniquement les étapes, notes et documents que le cabinet a rendus visibles pour le client, ainsi que les délais légaux. Il ne voit jamais la surveillance ni ses correspondances. L'ajout de personnes et le choix de ce que chacune peut voir ne sont pas encore dans l'application : adressez-vous à l'opérateur de la plateforme.",
      },
      deadlines: {
        q: "D'où viennent les délais des dossiers ?",
        a: "Un dossier ouvert à partir d'une correspondance commence avec le délai d'opposition propre au dépôt trouvé, repris de la publication du registre. Lorsque la règle qui fonde cette date n'a pas encore été confirmée par les juristes du cabinet — toute date de l'OMPI, et les republications par l'EUIPO d'enregistrements internationaux —, le délai est marqué provisoire : vérifiez-le avant de vous y fier. Tout autre délai est ajouté par un juriste sur la page du dossier. Le juriste responsable (ou, si personne n'est désigné, le compte principal du cabinet) reçoit un rappel une semaine avant, la veille, le jour même et une fois le délai dépassé — dans l'application, et par e-mail lorsque la plateforme envoie des e-mails et qu'il ne les a pas désactivés dans Paramètres.",
      },
      data: {
        q: 'Où nos données sont-elles conservées ?',
        a: 'La base de données et tous les fichiers téléversés sont conservés sur le serveur propre de la plateforme, dans un centre de données en Allemagne, au sein de l’UE — et non chez un service de stockage en nuage. La base de données est copiée chaque nuit et chaque copie est conservée jusqu’à 30 jours ; le disque entier du serveur est en outre sauvegardé. Le travail d’IA s’effectue sur notre propre matériel graphique en Bulgarie : il reçoit les marques à comparer et renvoie sa réponse. Lorsqu’un cas serré est transmis au modèle d’IA payant (Claude, d’Anthropic), celui-ci reçoit les deux marques comparées — leurs noms, leurs produits et services et une description écrite de leur éventuel logo — sans aucun nom de client ni fichier.',
      },
      search: {
        q: 'Comment trouver rapidement une marque, un client ou un dossier ?',
        a: "Appuyez sur ⌘K (Ctrl+K sous Windows) sur n'importe quelle page, ou cliquez dans le champ de recherche en haut, puis saisissez au moins deux lettres d'une marque, d'un client, ou du titre ou du numéro d'un dossier.",
      },
    },
  },

  notFound: {
    sub: "La page que vous cherchez n'existe pas ou a été déplacée.",
    back: "Retour à l'espace de travail",
  },
} as const
